module.exports = __webpack_public_path__ + "static/photo-male@2x-c2db4aefb6f03d1abe0c79837bf3d2a9.jpg";